/**
 * Save user availability via AJAX
 * @param {HTMLFormElement} form - The availability form element
 * @param {Array} availabilityData - Array of availability data
 * @returns {Promise<{success: boolean, message: string}>}
 */
export async function saveAvailability(form, availabilityData) {
	const formData = new FormData();
	formData.append('action', 'save_availability');

	const nonceInput = form.querySelector('input[name="availability_nonce"]');
	formData.append('nonce', nonceInput ? nonceInput.value : '');
	formData.append('availability', JSON.stringify(availabilityData));

	try {
		const response = await fetch(wpcore.ajaxUrl, {
			method: 'POST',
			body: formData,
		});
		const data = await response.json();

		return {
			success: data.success,
			message: data.success
				? wpcore.direct_t({ en: 'Availability updated successfully', fr: 'Disponibilité mise à jour avec succès' })
				: data.data?.message || wpcore.direct_t({ en: 'Failed to update availability', fr: 'Échec de la mise à jour de la disponibilité' }),
		};
	} catch (error) {
		console.error('AJAX Error:', error);
		return {
			success: false,
			message: wpcore.direct_t({ en: 'An error occurred. Please try again.', fr: 'Une erreur est survenue. Veuillez réessayer.' }),
		};
	}
}
